import $ from 'jquery'


export default {

  enable () {
    $('.tabbed-content').each((index, elem) => {
      
      let tabs = $(elem).find('.tab')
      let buttons = $(elem).find('.tab-button')
      $(tabs).first().addClass('active')
      $(buttons).first().addClass('active')

      $(elem).find('.tab-button').click((e) => {
        $(tabs).removeClass('active')
        $(buttons).removeClass('active')
        let target = $(e.target).attr('data-target')
        let targetTab = $(elem).find('#' + target)
        targetTab.addClass('active')
        $(e.target).addClass('active')

        // Pas très propre je sais
        setTimeout(() => {
          $('.partenaire-slider').flickity('resize')
        },10)
        
        
      })

    })

  }
}



// WEBPACK FOOTER //
// ./src/js/elements/tabbed-content.js